export default "/images/vendor/flag-icons/flags/1x1/pf.svg?be30b559c3943a7e07036c57aacf6f16";